import { gql } from '@apollo/client';

export const GET_PICKUP_ROUTE_BY_ID = gql`
  query GetPickupRouteById($id: Long!) {
    getPickupRouteWithDriverInfoById(id: $id) {
      id
      routeName
      warehouseId
      zipcodesListJson
      driverId
      driverName
      vehicleId
      vehicleModelId
      vehicleNumber
      licensePlate
      vehicleDisplayName
      vehicleModelName
      vehicleTypeName
      zipcodeCount
      createdAt
      updatedAt
    }
  }
`;

export interface GetPickupRouteByIdResponse {
  getPickupRouteWithDriverInfoById: {
    id: number;
    routeName: string;
    warehouseId: number;
    zipcodesListJson: string;
    driverId: number;
    driverName?: string;
    vehicleId?: number;
    vehicleModelId?: number;
    vehicleNumber?: string;
    licensePlate?: string;
    vehicleDisplayName?: string;
    vehicleModelName?: string;
    vehicleTypeName?: string;
    zipcodeCount: number;
    createdAt?: string;
    updatedAt?: string;
  } | null;
}

export interface GetPickupRouteByIdVariables {
  id: number;
}
